import { render } from "./AddTasksModal.vue?vue&type=template&id=2d7d4ac3&scoped=true"
import script from "./AddTasksModal.vue?vue&type=script&lang=js"
export * from "./AddTasksModal.vue?vue&type=script&lang=js"

import "./AddTasksModal.vue?vue&type=style&index=0&id=2d7d4ac3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7d4ac3"]])

export default __exports__